import { Setting } from './settings/setting.js'
import { UserRecord } from './auth/index.js'
import { BuildConfiguration } from './build/build-configuration.js'
import { UserTaskToken, UserTaskTokenDetails } from './types.js'

export const MappableSharedRootClasses = {
	UserRecord,
	Setting,
	BuildConfiguration,
	UserTaskToken,
	UserTaskTokenDetails,
} as const
